// extracted by mini-css-extract-plugin
export default {"melodyVideo":"wK-z","isFullWidth":"xK-z","landingPageVideo":"yK-z","play":"zK-z","iframeVideo":"AK-z","playHidden":"BK-z","fullwidth":"CK-z"};